export enum ProductGridTestIds {
  GRID_COMBINATION = 'grid-combination',
  GRID_CELL_QUANTITY = 'grid-cell-quantity',
  COMBINATION_PIECES_COUNTER = 'grid-combination-pieces-counter',
  COMBINATION_LINE_TOTAL = 'grid-combination-line-total',
  GRID_MENU_BUTTON = 'grid-menu-button',
  GRID_MENU_COPY = 'grid-menu-copy',
  GRID_PASTE_BUTTON = 'grid-paste-button',
}
